import '../../less/registration-common.less';
import { Icon } from 'antd';
import RegistrationCode409 from './codes/RegistrationCode409';
import RegistrationCode410 from './codes/RegistrationCode410';
import RegistrationCode412 from './codes/RegistrationCode412';
import RegistrationCode418 from './codes/RegistrationCode418';
import RegistrationCode428 from './codes/RegistrationCode428';

export default class Common extends React.Component {
    constructor(props) { super(props); }
    render() {
        const 
        { status, pendingCallback, successCallback, failureCallback, preComponentCallback } = this.props,
        iconStyle = { fontSize: '1.5em', marginRight: '8px' };
        switch(status) {
            case 409: 
                if (preComponentCallback) preComponentCallback(status);
                return (
                    <div>
                        <div className='ss-cmpts-reg-status-color-indicator-failure' />
                        <RegistrationCode409 />
                    </div>
                );

            case 410:
                if (preComponentCallback) preComponentCallback(status);
                return (
                    <div>
                        <div className='ss-cmpts-reg-status-color-indicator-failure' />
                        <RegistrationCode410 />
                    </div>
                );

            case 412:
                if (preComponentCallback) preComponentCallback(status);
                return (
                    <div>
                        <div className='ss-cmpts-reg-status-color-indicator-failure' />
                        <RegistrationCode412 />
                    </div>
                );
                
            case 418:
            	if(preComponentCallback) preComponentCallback(status);
            	return(
            			<div>
            			    <div className='ss-cmpts-reg-status-color-indicator-failure'/>
            				<RegistrationCode418 />
            			</div>
                        );
                        
             case 428:
                if(preComponentCallback) preComponentCallback(status);
                return(
                    <div>
                         <div className='ss-cmpts-reg-status-color-indicator-failure'/>
                         <RegistrationCode428 />
                    </div>
                    );

            case 'pending': 
                if(pendingCallback) pendingCallback(status);
                return (
                    <div className='ss-cmpts-reg-common-container'>
                        <Icon type='loading' style={iconStyle} />
                        <span className='ss-cmpts-reg-common-title'>
                            {'Attempting to create account...'}
                        </span>
                    </div>
                )
        

            case 'success': 
                if (successCallback) successCallback(status);
                return (
                    <div className='ss-cmpts-reg-common-container'>
                        <Icon type='check-circle' style={iconStyle} />
                        <span className='ss-cmpts-reg-common-title'>
                            {'Account was successfully created.'}
                        </span>
                    </div>
                );

            default: return (
                <div className='ss-cmpts-reg-common-container'>
                    <Icon type='close-circle' style={iconStyle} />
                    <span className='ss-cmpts-reg-common-title'>
                        {'Failure to create account.'}
                    </span>
                </div>
            );
        }
    }
}